import { View, Text, TouchableOpacity, TextInput } from "react-native";
import React, { useEffect, useState } from "react";

import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";

import { Feather, Ionicons } from "@expo/vector-icons";
import ExerciseDescriptionView from "./ExerciseDescriptionView";

import { v4 as uuidv4 } from "uuid";
import Serie from "../Firestore/Serie";

import { Observer, observer } from "mobx-react";
import { reaction, action } from "mobx";
import { useScreenDimensions, useDevice } from "../_layout";

import { useTranslation } from "react-i18next";
import { err } from "react-native-svg";
import LinkSlotView from "./LinkSlotView";
import CustomAlert from "../Components/CustomAlert";
import FloatingExerciseLink from "../Components/FloatingExerciseLink";
import Tooltip from "../Components/Tooltip";

const ExerciseRowView = observer(
  ({ exercise, showSetPriority, hideBlockDashboard }) => {
    const { t, i18n } = useTranslation();

    const { screenSize } = useScreenDimensions();
    const { isMobile } = useDevice();

    const [showingSlotLinkView, setShowingSlotLinkView] = useState(false);
    const [showingDeleteSlotLinkView, setShowingDeleteSlotLinkView] =
      useState(false);

    const [isRowHovered, setIsRowHovered] = useState(false);
    const [isLinkFloatingOpen, setIsLinkFloatingOpen] = useState(false);

    const deleteSlot = () => {
      // Grab a reference to the live protocols array
      const blockProtocols = exercise.workout.block.protocols;

      // Build a copy of all the ones you want to delete
      const matchingProtocols = blockProtocols.filter(
        (ex) =>
          ex.protocolSlot === exercise.protocolSlot &&
          ex.protocolWeek === exercise.getWeek &&
          (!exercise.isSecondaryProtocol || ex.isSecondaryProtocol)
      );

      // Remove each one by splicing it out of the original
      matchingProtocols.forEach((matching) => {
        const idx = blockProtocols.indexOf(matching);
        if (idx !== -1) {
          blockProtocols.splice(idx, 1);
        }
      });

      //delete second exercise if it exists
      const secondExercise = exercise.getSecondProtocol;
      // console.log("Deleting slot for exercise. SecondExercise: ", secondExercise);
      if (!exercise.isSecondaryProtocol && secondExercise) {
        secondExercise.setProperty("protocolSlot", null);
        secondExercise.setProperty("protocolWeek", null);
        secondExercise.setProperty("isSecondaryProtocol", false);
      }
      exercise.setProperty("protocolSlot", null);
      exercise.setProperty("protocolWeek", null);
      exercise.setProperty("isSecondaryProtocol", false);

      exercise.markChanged();
    };

    const RowView = () => {
      const [isTextInputFocused, setIsTextInputFocused] = useState(false);

      const workoutLibrary = exercise.workout.coach;

      const ExerciseName = observer(() => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            style={{
              flexShrink: 1,
            }}
            onPress={() => {
              exercise.workout.setSelectedExercise(exercise);
              if (exercise.workout.block && exercise.workout.block.client) {
                exercise.workout.block.client.setProperty(
                  "showingInfoView",
                  true
                );
              } else if (exercise.workout.coach) {
                exercise.workout.coach.setProperty("showingInfoView", true);
              } else if (exercise.workout.block.coach) {
                exercise.workout.block.coach.setProperty(
                  "showingInfoView",
                  true
                );
              }
            }}
          >
            <View
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{ opacity: isHovered ? 0.5 : 1 }}
            >
              <Text
                numberOfLines={2}
                style={[
                  Fonts.bold16,
                  { width: "100%", fontSize: screenSize === "small" ? 15 : 16 },
                ]}
              >
                {exercise.getName(t, i18n.language)}
              </Text>
              {exercise.protocolSlot && !hideBlockDashboard && (
                <Text
                  numberOfLines={1}
                  style={{
                    width: "100%",
                    fontSize: screenSize === "small" ? 11 : 12,
                    fontWeight: "500",
                    color: Colors.grayColor,
                  }}
                >
                  {t(exercise.protocolSlot)}
                </Text>
              )}
            </View>
          </TouchableOpacity>
        );
      });

      const SetsControl = observer(() => {
        const [isHovered, setIsHovered] = useState(false);

        const handleAddSet = () => {
          if (exercise.series.length < 20) {
            exercise.addSerie();
            exercise.markChanged();
          }
        };

        const handleDeleteSet = () => {
          if (exercise.series.length > 1) {
            exercise.deleteLastSerie();
          }
        };

        const canDelete = exercise.series.length > 1;
        const canAdd = exercise.series.length < 19;

        return (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: Colors.lightGrayColor,
              borderRadius: 8,
              paddingHorizontal: 2,
              paddingVertical: 3,
              marginLeft: 8,
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <TouchableOpacity
              onPress={handleDeleteSet}
              style={{
                padding: 2,
                opacity: canDelete ? (isHovered ? 1 : 0.6) : 0,
              }}
              disabled={!canDelete}
            >
              <Feather name="minus" size={12} color={Colors.darkgrayColor} />
            </TouchableOpacity>

            <Text
              style={{
                fontSize: 13,
                fontWeight: "500",
                color: Colors.blackColor,
                marginHorizontal: 6,
                width: 16,
                textAlign: "center",
              }}
            >
              {exercise.series.length}
            </Text>

            <TouchableOpacity
              onPress={handleAddSet}
              style={{
                padding: 2,
                opacity: canAdd ? (isHovered ? 1 : 0.6) : 0,
              }}
              disabled={!canAdd}
            >
              <Feather name="plus" size={12} color={Colors.darkgrayColor} />
            </TouchableOpacity>
          </View>
        );
      });
      const FoldExerciseButton = observer(() => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <TouchableOpacity
            onPress={() =>
              exercise.setProperty("isShown", !exercise.getProperty("isShown"))
            }
            style={{ opacity: isHovered ? 0.5 : 1 }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <Feather
              name={
                exercise.getProperty("isShown")
                  ? "chevron-down"
                  : "chevron-right"
              }
              size={20}
              color={Colors.bubbleColorConstant}
              style={{ paddingHorizontal: 10 }}
            />
          </TouchableOpacity>
        );
      });

      const LinkSlotButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <Tooltip
            content={
              exercise.protocolSlot
                ? "unlinkExerciseFromSlotTooltip-string"
                : "linkExerciseToSlotTooltip-string"
            }
            placement="top"
            delayedOpen={true}
          >
            <TouchableOpacity
              onPress={() => {
                if (exercise.protocolSlot) {
                  setShowingDeleteSlotLinkView(true);
                } else {
                  setShowingSlotLinkView(true);
                }
              }}
              style={{
                opacity: isRowHovered || isMobile ? (isHovered ? 0.5 : 1) : 0,
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {exercise.protocolSlot ? (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 4,
                    padding: 4,
                  }}
                >
                  <Ionicons
                    name="unlink-outline"
                    size={22}
                    color={Colors.grayColor}
                  />
                  {isHovered && (
                    <Text style={[Fonts.medium13, { color: Colors.grayColor }]}>
                      {t("SLOT")}
                    </Text>
                  )}
                </View>
              ) : (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 4,
                    padding: 4,
                  }}
                >
                  <Ionicons
                    name="link-outline"
                    size={22}
                    color={Colors.grayColor}
                  />

                  {isHovered && (
                    <Text style={[Fonts.medium13, { color: Colors.grayColor }]}>
                      {t("SLOT")}
                    </Text>
                  )}
                </View>
              )}
            </TouchableOpacity>
          </Tooltip>
        );
      };

      const ExerciseLinkButton = () => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <FloatingExerciseLink
            exercise={exercise}
            isOpen={isLinkFloatingOpen}
            onOpenChange={setIsLinkFloatingOpen}
            onClose={() => {
              setIsHovered(false);
              setIsLinkFloatingOpen(false);
            }}
          >
            <Tooltip
              content="addVideoLink-string"
              placement="top"
              delayedOpen={true}
              disabled={isLinkFloatingOpen}
            >
              <View
                style={{
                  opacity:
                    isRowHovered || isMobile || exercise.link
                      ? isHovered
                        ? 0.5
                        : 1
                      : 0,
                }}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Observer>
                  {() => (
                    <Feather
                      name="link"
                      size={17}
                      color={
                        exercise.link ? Colors.bubbleColor : Colors.grayColor
                      }
                    />
                  )}
                </Observer>
              </View>
            </Tooltip>
          </FloatingExerciseLink>
        );
      };
      return (
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              alignItems: "center",
              marginVertical: 2,
              paddingRight: 12,
            },
          ]}
          onMouseEnter={() => !isMobile && setIsRowHovered(true)}
          onMouseLeave={() =>
            !isTextInputFocused && !isLinkFloatingOpen && setIsRowHovered(false)
          }
        >
          <FoldExerciseButton />
          <ExerciseName />
          <View style={GlobalStyles.Spacer} />
          {!workoutLibrary && !hideBlockDashboard && <LinkSlotButton />}
          <View style={{ marginLeft: 8, marginRight: 4 }}>
            <ExerciseLinkButton />
          </View>

          <Text
            style={{
              fontSize: 12,
              fontWeight: "500",
              color: Colors.grayColor,
              marginLeft: 8,
            }}
          >
            {t("setsDots-string")}
          </Text>
          <SetsControl />
        </View>
      );
    };
    return (
      <View>
        <RowView />
        {exercise.getProperty("isShown") && (
          <ExerciseDescriptionView
            exercise={exercise}
            showSetPriority={showSetPriority}
          />
        )}
        {showingSlotLinkView && (
          <LinkSlotView
            isVisible={showingSlotLinkView}
            exercise={exercise}
            onClose={() => setShowingSlotLinkView(false)}
          />
        )}
        {showingDeleteSlotLinkView && (
          <CustomAlert
            isVisible={showingDeleteSlotLinkView}
            onClose={() => setShowingDeleteSlotLinkView(false)}
            title={"unlinkExerciseFromSlotWarningTitle-string"}
            text={
              !exercise.isSecondaryProtocol && exercise.getSecondProtocol
                ? t("unlinkExercisesFromSlotWarningText-string", {
                    firstExerciseName: exercise.getName(t, i18n.language),
                    secondExerciseName: exercise.getSecondProtocol.getName(
                      t,
                      i18n.language
                    ),
                    slotName: t(exercise.protocolSlot),
                  })
                : t("unlinkExerciseFromSlotWarningText-string", {
                    exerciseName: exercise.getName(t, i18n.language),
                    slotName: t(exercise.protocolSlot),
                  })
            }
            action={deleteSlot}
            specialCTA={"unlink-string"}
          />
        )}
      </View>
    );
  }
);

export default ExerciseRowView;
